import { API } from "../api";
import { AUTH_URL } from "../constants/url.constant";

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

export const setUser = (data) => ({
  type: LOGIN,
  payload: data
});

/**
 * Call login API
 * @param {*} username 
 * @param {*} password 
 * @returns 
 */
export const login = (username, password) => {
  return async (dispatch) => {
    try {
      const res = await API.post(AUTH_URL, { username, password });
      localStorage.setItem("role", res.user.role.id);
      localStorage.setItem("email", res.user.email);
      localStorage.setItem("roleName", res.user.role.name);
      localStorage.setItem("userId", res.user.id);
      localStorage.setItem("name", res.user.name);
      localStorage.setItem("clientId", res.clientId);
      localStorage.setItem("employeeId", res.employeeId);
      localStorage.setItem("hubCode", res.hubCode);
      localStorage.setItem("hubName", res.hubName);
      localStorage.setItem("menu", JSON.stringify(res.menu));
      localStorage.setItem("wmsVersion", res.wmsVersion || "1");
      localStorage.setItem("token", res.token);
      localStorage.setItem("permissions", JSON.stringify(res.permissions));
      localStorage.setItem("subClients", JSON.stringify(res.subClients));
      dispatch(setUser(res));
      return res;
    } catch (error) {
      console.error("login: error: ", error);
      throw error;
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    localStorage.clear();
    // localStorage.removeItem("role");
    // localStorage.removeItem("email");
    // localStorage.removeItem("roleName");
    // localStorage.removeItem("userId");
    // localStorage.removeItem("name");
    // localStorage.removeItem("clientId");
    // localStorage.removeItem("employeeId");
    // localStorage.removeItem("hubCode");
    // localStorage.removeItem("menu");
    // localStorage.removeItem("token");
    // localStorage.removeItem("hubName");
    // localStorage.removeItem("permissions");
    // localStorage.removeItem("subClients");
    dispatch({
      type: LOGOUT
    });
  };
};

export default function reducer(
  state = { isLoggedIn: localStorage.getItem("token") },
  { type, payload }
) {
  switch (type) {
    case LOGIN:
      return {
        ...state,
        menu: payload.menu,
        userInfo: payload.user,
        permissions: payload.permissions,
        isLoggedIn: true
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false
      };
    default:
      return state;
  }
}
